import { DoorOpen } from 'lucide-react'

import styles from './AssignSpeakerDialog.module.scss'

import type { GtSpeaker } from '@/api/internal'
import Button from '@/components/Button'
import DialogWrapper from '@/components/Dialog'

export interface AssignSpeakerDialogProps {
  isOpen: boolean
  currentSpeaker: GtSpeaker | null
  speakers: readonly GtSpeaker[]
  displayNames: ReadonlyMap<string, string>
  close: () => void
  onAssign: (speakerId: string) => void
  onEditCurrentSpeaker?: () => void
}

export const AssignSpeakerDialog = ({
  isOpen,
  currentSpeaker,
  speakers,
  displayNames,
  close,
  onAssign,
  onEditCurrentSpeaker,
}: AssignSpeakerDialogProps) => {
  const choices = speakers.filter((speaker) => speaker.id !== currentSpeaker?.id)

  return (
    <DialogWrapper isOpen={isOpen} title="Assign this turn" close={close} minWidth={360}>
      <div className={styles.body}>
        <p className={styles.description}>Choose who spoke in this turn. Other turns won&apos;t change.</p>
        {choices.length > 0 ? (
          <div className={styles.choices}>
            {choices.map((speaker) => (
              <button key={speaker.id} type="button" className={styles.choice} onClick={() => onAssign(speaker.id)}>
                {speaker.kind === 'room' && <DoorOpen size={13} aria-hidden="true" />}
                <span>{displayNames.get(speaker.id) ?? speaker.name}</span>
                {speaker.hotkey && <kbd className={styles.hotkey}>{speaker.hotkey}</kbd>}
              </button>
            ))}
          </div>
        ) : (
          <p className={styles.empty}>Add another speaker to the roster before assigning this turn.</p>
        )}
        <div className={styles.actions}>
          {currentSpeaker && onEditCurrentSpeaker && (
            <Button
              title={currentSpeaker.kind === 'room' ? 'Name this voice for all turns' : 'Rename this speaker'}
              type="link"
              onClick={onEditCurrentSpeaker}
            />
          )}
          <Button title="Cancel" type="link" onClick={close} />
        </div>
      </div>
    </DialogWrapper>
  )
}
